// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors.0a802f460e4843e5d2a8.js";
	// return url for filenames based on template
	return "" + chunkId + ".chunk.bundle.js";
};